import { Typography } from "@mui/material";

type IProps = {
  title: string;
  variant?: "h4" | "h5" | "h6";
};

const Title: React.FC<IProps> = ({ title, variant = "h4" }) => {
  return (
    <Typography variant={variant} component="h1" align="center" sx={{ my: 2 }}>
      {title}
    </Typography>
  );
};

export default Title;
